const TOKEN_KEY = 'AuthToken'

export const saveToken = (token: string) => {
  window.localStorage.setItem(TOKEN_KEY, token)
}

export const removeToken = () => window.localStorage.removeItem(TOKEN_KEY)

export const getToken = () => {
  const token = window.localStorage.getItem(TOKEN_KEY)
  return token || ''
}
